import React from 'react'
import { List, ListItem, Typography, Box } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import DonutLargeOutlinedIcon from '@mui/icons-material/DonutLargeOutlined'
import MapOutlinedIcon from '@mui/icons-material/MapOutlined'

import { innerContentSidebarSx } from '@/layout-blueprints/chromeComponentSx'

/**
 * Sidebar component for property page navigation
 */
const PropertySidebar = ({ isOpen, activeTab, onTabChange  }) => {
  const menuItems = [
    {
      id: 'Summary',
      label: 'Property Summary',
      icon: <DonutLargeOutlinedIcon sx={{ mr: '0.5rem' }} />,
      section: 'Property',
    },
    {
      id: 'Comps',
      label: 'Comps',
      icon: <FontAwesomeIcon icon={['far', 'house-circle-check']} />,
      section: 'Area',
    },
    {
      id: 'MarketAnalysis',
      label: 'Market Analysis',
      icon: <MapOutlinedIcon sx={{ mr: '0.5rem' }} />,
      section: 'Area',
    },
  ]

  const groupedItems = menuItems.reduce((acc, item) => {
    if (!acc[item.section]) {
      acc[item.section] = []
    }
    acc[item.section].push(item)
    return acc
  }, {})

  return (
    <Box
      sx={[
        innerContentSidebarSx({ size: 'lg', open: isOpen  }),
        { backgroundColor: '#fff', order: 1 },
      ]}
    >
      <Box sx={{
        position: "relative",
        height: "100%",
        maxHeight: "100%",
        overflowX: "hidden",
        overflowY: "auto",
        WebkitOverflowScrolling: "touch",
      }}>
        <Box sx={{ px: '1.5rem', pt: '1.5rem' }}>
          {Object.entries(groupedItems).map(([section, items]) => (
            <div key={section}>
              <List component="div" sx={[{
                width: "100%",
                "& .MuiListItem-root, & .MuiListItemButton-root": { borderRadius: "0.65rem", width: "100%" },
                "& .MuiListItem-root, & .MuiListItemButton-root, .MuiList-root.nav-transparent-alt .MuiListItem-root, .MuiList-root.nav-transparent-alt .MuiListItemButton-root": { width: "100%" },
                "& .MuiListItem-root.MuiListItem-button, & .MuiListItemButton-root": { borderRadius: "0.65rem", width: "100%" },
              }, { flexDirection: 'column' }, {
                "& .MuiListItem-root.MuiListItem-button.Mui-selected, & .MuiListItem-root.MuiListItem-button:hover, & .MuiListItemButton-root.Mui-selected, & .MuiListItemButton-root:hover": {
                  color: "#368cff",
                  background: "rgba(54, 140, 255, 0.05)",
                  "&::before": { background: "#368cff" },
                },
              }]}>
                <ListItem
                  sx={{
                    display: 'flex',
                    px: 0,
                    pt: '0.25rem',
                    pb: '0.25rem',
                    justifyContent: 'space-between',
                  }}
                >
                  <Box sx={[{ textTransform: 'uppercase', color: '#368cff', fontWeight: 700, }, { fontSize: "0.875rem !important" }]}>
                    {section}
                  </Box>
                </ListItem>
                {items.map((item) => (
                  <ListItem
                    key={item.id}
                    component="a"
                    button
                    href={null}
                    onClick={(e) => onTabChange(item.id)}
                    selected={activeTab === item.id}
                  >
                    {item.icon}
                    {item.label}
                  </ListItem>
                ))}
              </List>
              <Box sx={[{ my: '0.25rem' }, { background: "#eeeff8", height: "1px", overflow: "hidden" }]} />
            </div>
          ))}
        </Box>
      </Box>
    </Box>
  )
}

export default PropertySidebar
